import { api } from "./apiSlice";

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export interface BloodDonationRecord {
  id: string;
  startTime: string;
  endTime: string;
  pointsEarned: number;
  userId: string | null;
  userName: string | null;
  userNic: string | null;
  userBloodGroup: string | null;
  userDistrict: string | null;
}

export interface CreateBloodDonationInput {
  bdfId: string;
  userId?: string;
  numberOfDonations?: number;
  pointsEarned: number;
  startTime: string;
  endTime: string;
  emergencyRequestId?: string;
  bloodUnits: Array<{ inventoryId?: string; volume: number; bagType: string; expiryDate: string }>;
}

export interface PastDonation {
  startTime: string;
  endTime: string;
  establishmentName: string | null;
}

export const bloodDonationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBloodDonations: builder.query<BloodDonationRecord[], void>({
      query: () => "/blood-donation",
      transformResponse: (res: ApiResponse<{ donations: BloodDonationRecord[] }>) => res.data.donations,
      providesTags: ["BloodDonation"],
    }),
    createBloodDonation: builder.mutation<unknown, CreateBloodDonationInput>({
      query: (body) => ({ url: "/blood-donation", method: "POST", body }),
      invalidatesTags: ["BloodDonation", "Blood", "Inventory"],
    }),
    getDonationHistoryByDonor: builder.query<PastDonation[], string>({
      query: (donorId) => `/donations/history/by-donor?donorId=${encodeURIComponent(donorId)}`,
      transformResponse: (res: ApiResponse<{ donations: PastDonation[] }>) => res.data.donations,
    }),
  }),
});

export const { useGetBloodDonationsQuery, useCreateBloodDonationMutation, useGetDonationHistoryByDonorQuery } = bloodDonationApi;
